import { colors, mixin } from "@hubrise/react-components"
import styled from "styled-components"

export const List = styled.ul`
  list-style: disc inside;
  margin-top: 0.5em;
`

export const Item = styled.li`
  line-height: 1.5em;
  white-space: nowrap;
`

export const ItemMore = styled.div`
  display: inline-block;
  width: 100%;
  ${mixin.clickable};
  :before {
    content: "...";
  }
`

export const FoldBar = styled.li`
  list-style: none;
  display: flex;
  justify-content: center;
  ${mixin.clickable};
  line-height: 2em;

  :hover {
    background-color: ${colors.backgroundLightest};
  }
`

export const FoldLabel = styled.div`
  display: flex;
  gap: 0.5em;
  color: ${colors.textMedium};
  align-items: center;
`

export const FoldText = styled.div`
  text-decoration: underline;
`
